import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './AdminNotificationPopup.scss';
import { ResolvedAdminNotification } from '../../../types/notifications/Notification';

interface AdminNotificationPopupProps {
  notification: ResolvedAdminNotification | null;
  visible: boolean;
  onHide: () => void;
}

// Standard popup with the fuller description of an admin-authored notification.
const AdminNotificationPopup: React.FC<AdminNotificationPopupProps> = ({
  notification,
  visible,
  onHide,
}) => {
  if (!notification) {
    return null;
  }

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={notification.title}
      className="dialog-box admin-notification-popup"
      dismissableMask
      draggable={false}
      resizable={false}
    >
      {notification.description && (
        <div className="admin-notification-popup__body">{notification.description}</div>
      )}
      {notification.ctaUrl && (
        <div className="admin-notification-popup__cta">
          <a href={notification.ctaUrl} target="_blank" rel="noreferrer">
            <Button className="btn" label={notification.ctaLabel || notification.ctaUrl} />
          </a>
        </div>
      )}
    </Dialog>
  );
};

export default AdminNotificationPopup;
